import React from 'react';

export default {
  width: 76,
  height: 32,
  content: (
    <>
      <path fill="#fff" d="M70.4105 12.8119H0l6.41024-6.40167L0 0h70.4105l6.4016 6.41023-6.4016 6.40167z"/>
      <path fill="#010101" d="M1.96875 32.0001V19.1882h3.86791l4.29044 4.9744v-4.9744h4.8731v12.8119h-3.8597l-4.29866-4.9829v4.9829H1.96875zm21.46005 0h-4.8647V19.1882h4.8647v12.8119zm51.4165 0l-4.6199-6.4017 4.6199-6.4102h-5.515l-1.8664 2.7955-1.8666-2.7955h-5.515l4.6199 6.4102-4.6199 6.4017h5.5234l1.8582-2.8968 1.858 2.8968h5.5234zm-20.3623 0h4.9238l-4.8141-12.8119h-5.2362l-4.8223 12.8119h4.9238l.4476-1.4611h4.1298l.4476 1.4611zm-3.5724-4.7633l1.0641-3.4796 1.0557 3.4796h-2.1198zm-12.398-8.0486L34.9317 25.1l-3.5809-5.9118h-4.358v12.8119h4.8731v-5.1433l1.6891 2.7701h2.8293l1.6468-2.7363v5.0673h4.8731V19.146l-4.3916.0422z"/>
    </>
  )
};